import { CASE_TYPE_DICTIONARY, CASE_TYPE_CODE } from '@/utils/utils.js'
import { dateformat, getStore, setStore } from "../../utils/utils";

export const caseListMixins = {//获取工作人员角色列表
    data() {
        return {
            typeOptions:  [{label: '所有案件', value: ''}].concat(CASE_TYPE_DICTIONARY),
            case_type_code: CASE_TYPE_CODE,
            currentLoginUserId: null
        }
    },
    created() {
        let loginInfo = JSON.parse(getStore('loginInfo_worker'))
        this.currentLoginUserId = loginInfo.userInfo.userId
    },
    mounted() {
    },
    activated() {
    },
    methods: {
        formatDate (mtime) {
            if (!mtime.orderTime) { return; }
            if (mtime.orderTime == '-') return mtime.orderTime
            let date = new Date(mtime.orderTime);
            return dateformat(date, 'yyyy-MM-dd hh:mm');
        },
        formatEndDate (mtime) {
            if (!mtime.endTime) { return; }
            if (mtime.endTime == '-') return mtime.endTime
            let date = new Date(mtime.endTime);
            return dateformat(date, 'yyyy-MM-dd hh:mm');
        },
        formatStatus(status){
            console.log('formatStatus', status)
            if (!status.mediationStatusStr) { return '未开始'; }
            let statusName = ''
            switch (status.mediationStatusStr) {
                case 'INIT':
                    statusName = '未开始'
                    break;
                case 'RUNNING':
                    statusName = '进行中'
                    break;
                case 'END':
                    statusName = '已结束'
                    break;
                case 'END_CANCEL':
                    statusName = '已结束'
                    break;
                default:
            }
            return statusName
        },
        //进入视频
        enterVedio(params){
            let loginInfo = getStore('loginInfo_worker')
            setStore("loginInfo", loginInfo);

            if(this.currentLoginUserId===params.creatorId){
                this.$router.push({
                    path: '/meeting/mediator',
                    query: {
                        roomid: params.roomId,
                        caseid: params.caseId,
                        meetingid:params.id,
                    }
                })
            } else {
                this.$router.push({
                    path: '/meeting/member',
                    query: {
                        roomid: params.roomId,
                        caseid:params.caseId,
                        meetingid:params.id,
                    }
                })
            }
        },
        enterCaseDetail(row, isClosed){
            let spaceType = 0
            if (row.mediationMeetingTypeCode == CASE_TYPE_CODE.ASYNCHRONOUS_MEDIATE) {
                spaceType = 1
            } else if (row.mediationMeetingTypeCode === CASE_TYPE_CODE.ONLINE_SERVICE) {
                spaceType = 2
            }
            let flk = getStore('flk');
            let loginInfo = JSON.parse(getStore('loginInfo_worker'))
            let path = `/caseSpace?roomid=${row.roomId}&activeName=first&activeIndex=0&caseid=${row.caseId}&meetingid=${row.id}&flk=${flk}&userId=${loginInfo.userInfo.userId}&isClosed=${isClosed}&spaceType=${spaceType}`
            window.open(path, '_blank')
        },
        checkDetail(row){
            this.$router.push({
                path: '/meeting/meetingDetail',
                query:{
                    caseId:row.caseId,
                    meetingId:row.id,
                }
            });
        },
        changepage(value) {
            this.curIndex = value
            this.seachList(1)
        },
    }
}
